import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageLoading } from '../../components/page';
import { useTherapyContext } from '../../contexts';
import { getRoute } from '../../routes';

export const PatientPortalPage = (): JSX.Element => {
  const navigate = useNavigate();
  const { hasLoaded, navigateToPatientPortal } = useTherapyContext();

  const [hasOpened, setHasOpened] = useState(false);

  useEffect(() => {
    if (hasLoaded) {
      void navigateToPatientPortal().then(() => setHasOpened(true));

      navigate(getRoute('home', {}));
    }
  }, [hasLoaded]);

  useEffect(() => {
    // After the patient portal opens in a new tab, route to the home page.
    if (hasOpened) {
      navigate(getRoute('home', {}));
    }
  }, [hasOpened]);

  return <PageLoading pageName="patient portal" />;
};
